<script>
    export default {
        name: "SearchEvent",
        methods: {
            searchButtonHasClicked: function (event) {
                if (event.keyCode !== 13 && event.keyCode !== void 0) {
                    return;
                }

                const currentRouteName = this.$route.name;

                this.searchArticles();

                if (currentRouteName !== 'Articles') {
                    this.$router.push({ name: 'Articles'});
                }

                this.$emit('search-button-has-clicked');
            }
        }
    }
</script>


